let apidaePrestasListe = {
    delimiters: ['%%', '%%'],
    props: {
        title: String,
        type: String,
        prestaItems: Array,
        lang: String,
        showdate: Number,
        showtarif: Number
    },
    template: `
        <div class="PrestasListe">
            <ul class="liste-prestaList no-bullet" v-cloak v-if="type === 'list'">
                <li class="list__item" v-for="(prestaItem, index) in prestaItems">
                    <a v-bind:href="prestaItem.url" class="single-item">
                        <strong>%% prestaItem.title %%</strong><span class="list__commune" v-if="!!prestaItem.commune">, %% prestaItem.commune %%</span>
                    </a>
                </li>
            </ul>
            <div :class="(type == 'slide') ? 'slider-prestaList owl-carousel owl-theme' : 'grid'" v-else>
                <div class="grid__item" v-for="(prestaItem, index) in prestaItems" v-cloak>
                    <a v-bind:href="prestaItem.url" class="single-item">
                        <div class="grid__img">
                            <img v-if="!!prestaItem.prestaVO.images.length > 0" v-bind:src="prestaItem.prestaVO.images[0].miniUrl" alt="" width="324" height="215" />
                            <img v-else src="https://via.placeholder.com/324x215" alt="" width="324" height="215" />
                        </div>
                        <div class="grid__inner">
                            <h2 v-html="prestaItem.title"></h2>
                            <p v-html="$options.filters.stripTags(prestaItem.description)"></p>
                            <div class="date" v-if="showdate">
                                <div class="date-double" v-if="prestaItem.prestaVO.dateDebut != prestaItem.prestaVO.dateFin">
                                    <div class="dateDebut">
                                        <span class="day">%% prestaItem.prestaVO.dateDebut | formatDate('Do', lang) %%</span>
                                        <span class="month">%% prestaItem.prestaVO.dateDebut | formatDate('MMM', lang) %%</span>
                                        <span class="year">%% prestaItem.prestaVO.dateDebut | formatDate('YY', lang) %%</span>
                                    </div>
                                    <div class="dateFin">
                                        <span class="day">%% prestaItem.prestaVO.dateFin | formatDate('Do', lang) %%</span>
                                        <span class="month">%% prestaItem.prestaVO.dateFin | formatDate('MMM', lang) %%</span>
                                        <span class="year">%% prestaItem.prestaVO.dateFin | formatDate('YY', lang) %%</span>
                                    </div>
                                </div>
                                <div class="date-simple" v-else>
                                    <div class="dateDebut">
                                        <span class="day">%% prestaItem.prestaVO.dateDebut | formatDate('Do', lang) %%</span>
                                        <span class="month">%% prestaItem.prestaVO.dateDebut | formatDate('MMM', lang) %%</span>
                                        <span class="year">%% prestaItem.prestaVO.dateDebut | formatDate('YY', lang) %%</span>
                                    </div>
                                </div>
                            </div>
                            <div class="grid__sub">
                                <div class="grid__datetime">
                                    <span v-if="!!prestaItem.dureeSejour">%% prestaItem.dureeSejour %%</span>
                                    <span class="grid__commune" v-if="!!prestaItem.commune"><i class="fad fa-map-marker-alt"></i> %% prestaItem.commune %%</span>
                                </div>
                                <div class="grid__price" v-if="showtarif">
                                    <span v-if="prestaItem.tarifMin">à partir de</span> <span v-if="prestaItem.tarifMin">%% prestaItem.tarifMin %% &euro;</span><span v-else-if="prestaItem.tarifMax">%% prestaItem.tarifMax %% &euro;</span>
                                </div>
                            </div> 
                        </div>
                    </a>
                </div>
            </div>
        </div>`
  };

  